import React from 'react';
import './PartnerWithUs.css';

const PartnerWithUs = () => (
  <section className="partner-section" id="partner">
    <div className="container">
      <h2 className="section-title">Partner With Us</h2>
      <p className="partner-text">
        Looking to import premium Soapstone, Magnesite, Calcium Carbonate, Feldspar, or Granite?<br /><br />
        <strong>Silverstone Enterprises</strong> is ready to be your long-term, reliable supplier.
        <br /><br />
        Get in touch today for <strong>samples, specifications, or bulk inquiries</strong>.
      </p>
      <div className="partner-cta">
        <button className="partner-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
          <span>Start Partnership</span>
          <span className="btn-arrow">→</span>
        </button>
      </div>
    </div>
  </section>
);

export default PartnerWithUs;
